<template>
  <div class="content">
    <div class="search-bar">
      <div class="row">
        <div class="col-md-8">
          <ArtistSelect
            @memberChangeEvent="onMemberChange"
            :is-filter="true"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
            :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
          />
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">채널</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select class="select-primary" style="width: 100%" size="large" placeholder="채널" v-model="search.namespace">
                <el-option
                  v-for="option in namespaceOptions"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div v-if="search.namespace == 800" class="col-md-12 text-left">
              <el-select class="select-primary" style="width: 100%" size="large" placeholder="카테고리" v-model="search.category">
                <el-option label="명언" value="quotation"></el-option>
                <el-option label="TMI" value="tmi"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <h4 class="card-title text-left">상태</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select class="select-primary" style="width: 100%" size="large" placeholder="상태" v-model="search.state">
                <el-option
                  v-for="option in commentStateOptions"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">기간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="search.period" />
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <h4 class="card-title text-left">검색어</h4>
          <div class="row">
            <div class="col-md-5 text-left">
              <el-select class="select-primary" style="width: 100%" size="large" placeholder="채널" v-model="search.keywordScope">
                <el-option
                  v-for="option in keywordScopeOptions"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div class="col-md-7 text-left">
              <el-input placeholder="검색어를 입력해 주세요" v-model="search.keyword" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <base-button @click.self="onClickSearch" native-type="submit" type="primary">검색</base-button>
        </div>
      </div>
    </div>
    <div class="row">
      <CommentsTableView
        class="col-md-12"
        :namespace="search.namespace"
        :unitId="search.unitId"
        :comments="comments"
        :page-count="pageCount"
        :category="search.category"
        @onPageChange="onPageChange"
        @onDeleteConfirmed="onDeleteConfirmed"
        @onRestoreConfirmed="onRestoreConfirmed"
      />
    </div>
  </div>
</template>

<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Toast } from "@/util/Toast";
import moment from "moment";
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import { ContentNamespace, ContentNamespaceOptions } from "@/common/ContentNamespace";
import { CommentState, CommentStateOptions } from "@/common/CommentState";
import CommentsTableView from "@/pages/Comments/CommentsTableView";

const DEFAULT_UNIT_ID = 1;
const DEFAULT_SEARCH_NAMESPACE = ContentNamespace.RADAR;
const DEFAULT_SEARCH_STATE = CommentState.PRESENT;
const DEFAULT_SEARCH_KEYWORD_SCOPE = "nickname";

export default {
  name: "CommentContents",
  components: {
    ArtistSelect,
    CommentsTableView,
  },
  async created() {
    const { unitId, artistId, namespace, state, startDate, endDate, keywordScope, keyword, category } = this.$route.query;

    this.search.unitId = unitId ? parseInt(unitId, 10) : DEFAULT_UNIT_ID;
    this.search.artistId = artistId ? parseInt(artistId, 10) : null;
    this.search.namespace = namespace ? parseInt(namespace, 10) : DEFAULT_SEARCH_NAMESPACE;
    this.search.category = category ? category : "quotation";
    this.search.state = state ? parseInt(state, 10) : DEFAULT_SEARCH_STATE;
    if (startDate && endDate) {
      this.search.period = [moment(startDate, "YYYY-MM-DD").toDate(), moment(endDate, "YYYY-MM-DD").toDate()];
    }
    this.search.keywordScope = keywordScope || DEFAULT_SEARCH_KEYWORD_SCOPE;
    this.search.keyword = keyword || null;
    this.search.page = 1;

    this.onClickSearch();
  },
  data() {
    return {
      search: {
        unitId: DEFAULT_UNIT_ID,
        artistId: null,
        namespace: DEFAULT_SEARCH_NAMESPACE,
        state: DEFAULT_SEARCH_STATE,
        period: null,
        category: "quotation",
        keywordScope: DEFAULT_SEARCH_KEYWORD_SCOPE,
        keyword: null,
        page: 1,
      },
      comments: [],
      pageCount: 1,
      namespaceOptions: ContentNamespaceOptions,
      commentStateOptions: CommentStateOptions,
      keywordScopeOptions: [
        {
          label: "닉네임",
          value: "nickname",
        },
        {
          label: "e-mail",
          value: "email",
        },
      ],
    };
  },
  methods: {
    async onMemberChange(change) {
      this.search.unitId = change.unitId;
      this.search.artistId = change.memberId;
    },
    async onClickSearch() {
      const queryParams = {
        unitId: this.search.unitId,
        artistId: this.search.artistId || undefined,
        namespace: this.search.namespace || undefined,
        category: this.search.category || undefined,
        state: this.search.state,
      };

      if (!_.isEmpty(this.search.keyword)) {
        queryParams.keywordScope = this.search.keywordScope;
        queryParams.keyword = this.search.keyword;
      }

      if (this.search.period) {
        queryParams.startDate = this.search.period?.[0] ? moment(this.search.period[0]).format("YYYY-MM-DD") : undefined;
        queryParams.endDate = this.search.period?.[1] ? moment(this.search.period[1]).format("YYYY-MM-DD") : undefined;
      }

      try {
        await this.$router.push(`/comment/contents?${URLUtils.objectToQueryString(queryParams)}`);
      } catch (err) {
        // 같은 경로인 경우 error 가 발생합니다.
        // naive 한 방법이긴 하지만, 이런 경우 단순히 reload 합니다.
        await this.fetchComments();
      }
    },
    getSearchParams() {
      const searchParams = {
        unitId: this.search.unitId,
        artistId: this.search.artistId || undefined,
        namespace: this.search.namespace,
        category: this.search.category,
        state: this.search.state,
        startTime: this.search.period?.[0] ? moment(this.search.period[0]).hour(0).minute(0).second(0).toISOString(true) : undefined,
        endTime: this.search.period?.[1] ? moment(this.search.period[1]).hour(23).minute(59).second(59).toISOString(true) : undefined,
        page: this.search.page,
        pageSize: 20,
      };

      if (!_.isEmpty(this.search.keyword)) {
        if (this.search.keywordScope === "nickname") {
          searchParams.nickname = this.search.keyword;
        } else if (this.search.keywordScope === "email") {
          searchParams.email = this.search.keyword;
        }
      }

      return searchParams;
    },
    async fetchComments() {
      try {
        const queryParams = this.getSearchParams();
        const result = await this.$axios.get(`/comments?${URLUtils.objectToQueryString(queryParams)}`);
        this.comments = result.data.data;

        this.fetchCommentPageCount();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async fetchCommentPageCount() {
      const queryParams = this.getSearchParams();
      delete queryParams.page;
      try {
        const result = await this.$axios.get(`/comments/pageCount?${URLUtils.objectToQueryString(queryParams)}`);
        this.pageCount = result.data.data.pageCount;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onPageChange(newPage) {
      this.search.page = newPage;
      await this.fetchComments();
    },
    async onDeleteConfirmed(commentId) {
      const queryParams = {
        namespace: this.search.namespace,
        commentId,
      };

      try {
        const result = await this.$axios.delete(`/comments?${URLUtils.objectToQueryString(queryParams)}`);
        Toast.success(result.data.data.message);

        this.fetchComments();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onRestoreConfirmed(commentId) {
      const bodyParams = {
        namespace: this.search.namespace,
        commentId,
      };

      try {
        const result = await this.$axios.put(`/comments/restore`, bodyParams);
        Toast.success(result.data.data.message);

        this.fetchComments();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickDetail(topic) {
      this.$router.push(`/topic/detail/${topic.id}`);
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  margin-bottom: 10px;
}
</style>
